export default __webpack_public_path__ + "static/N0081-2c19f5d9cce3f13a1da630ff9334a48e.png";